export const environment = {
  production: true,
  //   url: "https://test-admin.guarented.com",
  url: "https://admin.guarented.com",
  // url: 'http://localhost:8467'
};
